import StudentPortalRouter from "./StudentPortalRouter";

export default StudentPortalRouter;
